import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../store.js';

export default function Login() {
  const session = useSession();
  const navigate = useNavigate();
  const [workerUrl, setWorkerUrl] = useState(session.workerUrl);
  const [bearer, setBearer] = useState('');
  const [accountId, setAccountId] = useState(session.accountId);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const base = workerUrl.replace(/\/$/, '');
      const res = await fetch(`${base}/ping`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${bearer}`,
          'X-Account-Id': accountId,
          'X-Device-Id': session.deviceId || 'dashboard-spa',
        },
      });
      if (!res.ok) {
        const body = await res.text();
        throw new Error(`auth failed (${res.status}): ${body || res.statusText}`);
      }
      session.set({ workerUrl: base, bearer, accountId });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-frame">
      <form className="login-card" onSubmit={submit}>
        <h1>Sign in</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--type-control)' }}>
          Enter your worker URL, bearer token, and account id. Credentials are
          stored in this browser's localStorage only.
        </p>

        <label>
          Worker URL
          <input
            type="url"
            required
            value={workerUrl}
            onChange={(e) => setWorkerUrl(e.target.value)}
            placeholder="https://bvs-sync.your-subdomain.workers.dev"
          />
        </label>

        <label>
          Bearer token
          <input
            type="password"
            required
            value={bearer}
            onChange={(e) => setBearer(e.target.value)}
            placeholder="paste BEARER_TOKEN or REVIEWER_BEARER"
          />
        </label>

        <label>
          Account id
          <input
            type="text"
            required
            value={accountId}
            onChange={(e) => setAccountId(e.target.value)}
            placeholder="bvs-..."
          />
        </label>

        {error && <div className="error-text">{error.message}</div>}

        <div className="actions">
          <button className="btn" type="submit" disabled={busy}>
            {busy ? 'Checking…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}
